import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function TrendingFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.289 9.187C5.319 10.615 4.5 12.149 4.5 14c0 4.418 3.57 8 7.972 8 4.402 0 7.473-4 6.975-8-.334-2.684-2.268-4.395-3.792-5.744-.73-.646-1.366-1.209-1.688-1.756-.827-1.401-.792-2.564-.64-3.356l.032-.151a8.05 8.05 0 01.123-.48c.093-.332.144-.513-.014-.513-.107 0-.428.137-.845.402a6.823 6.823 0 00-.179.118C10.892 3.577 8.358 6.201 9.981 10c1.067 2.5.185 5 0 5-.499 0-1.383-.75-1.993-2.5-.363-1.04-.537-2.202-.656-3.064l-.024-.178-.02-.142c-.05-.361-.091-.646-.138-.811-.044-.155-.094-.205-.159-.114a51.958 51.958 0 00-.702.996z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(TrendingFill);
export default ForwardRef;